import {
  appendKitUtmFields,
  getFirstTouch,
  recordSignup,
} from "./utmTracking";

/** Kit.com form (uid eaf0fcb761); https://ignite-elysium.kit.com/eaf0fcb761 */
export const KIT_FORM_ID = "10047178";
export const KIT_SUBSCRIBE_URL = `https://app.kit.com/forms/${KIT_FORM_ID}/subscriptions`;
export const KIT_SUPPORT_EMAIL = "connect@ignite-elysium.com";

const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmailAddress = (value) =>
  EMAIL_PATTERN.test(String(value || "").toLowerCase());

export const kitErrorMessage = (payload) => {
  const messages = payload?.errors?.messages;
  if (Array.isArray(messages) && messages.length > 0) {
    return messages.filter(Boolean).join(" ");
  }
  if (typeof payload?.message === "string" && payload.message) {
    return payload.message;
  }
  return `We could not add that email. Please try again, or write ${KIT_SUPPORT_EMAIL}.`;
};

export const subscribeToKit = async (email) => {
  const body = new FormData();
  body.append("email_address", email);
  if (typeof window !== "undefined" && window.location?.href) {
    body.append("referrer", window.location.href);
  }
  appendKitUtmFields(body, getFirstTouch());

  const response = await fetch(KIT_SUBSCRIBE_URL, {
    method: "POST",
    body,
    headers: { Accept: "application/json" },
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (payload?.status === "failed" || !response.ok) {
    throw new Error(kitErrorMessage(payload));
  }

  void recordSignup();
  return payload;
};
